"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _base = babelHelpers.interopRequireDefault(require("./base"));

var _exports = babelHelpers.interopRequireDefault(require("exports"));

var _react = babelHelpers.interopRequireWildcard(require("react"));

var _decorators = require("decorators");

var _classList = babelHelpers.interopRequireDefault(require("class-list"));

var _class, _descriptor, _descriptor2, _temp;

var SubscriptionCard = (_class = (_temp =
/*#__PURE__*/
function (_Card$makeDefaultCard) {
  babelHelpers.inherits(SubscriptionCard, _Card$makeDefaultCard);

  function SubscriptionCard() {
    var _babelHelpers$getProt;

    var _this;

    babelHelpers.classCallCheck(this, SubscriptionCard);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt = babelHelpers.getPrototypeOf(SubscriptionCard)).call.apply(_babelHelpers$getProt, [this].concat(args)));
    _this.state = {
      selectedTab: 0
    };
    babelHelpers.initializerDefineProperty(_this, "buyButtonAction", _descriptor, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "id", _descriptor2, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    return _this;
  }

  babelHelpers.createClass(SubscriptionCard, [{
    key: "renderBottomContent",
    value: function renderBottomContent() {
      var _this2 = this;

      if (!this.isPurchaseTile || this.pricingOptions.length == 1) return babelHelpers.get(babelHelpers.getPrototypeOf(SubscriptionCard.prototype), "renderBottomContent", this).call(this);
      return _react.default.createElement("div", {
        "data-subscription-id": this.objectId
      }, _react.default.createElement("ul", {
        className: "nav nav-tabs"
      }, this.pricingOptions.map(function (opt, index) {
        return _react.default.createElement("li", {
          key: index,
          className: index == _this2.state.selectedTab ? 'active' : ''
        }, _react.default.createElement("a", {
          onClick: _this2.selectTab,
          "data-index": index
        }, opt.tabTitle));
      })), _react.default.createElement("div", {
        className: "tab-content"
      }, this.pricingOptions.map(function (opt, index) {
        return _react.default.createElement("div", {
          key: index,
          className: _classList.default.join('tab-pane', index == _this2.state.selectedTab ? 'active' : ''),
          "data-price": opt.type
        }, _react.default.createElement("div", {
          className: "price"
        }, _react.default.createElement("div", {
          dangerouslySetInnerHTML: {
            __html: opt.priceText
          }
        }), opt.freeText && _react.default.createElement("div", {
          className: "freeTrial",
          dangerouslySetInnerHTML: {
            __html: opt.freeText
          }
        })), _react.default.createElement("div", {
          className: "purchase"
        }, _react.default.createElement("a", {
          className: "btn btn-primary buy-button",
          onClick: _this2.buyButtonAction,
          "data-target": _this2.id,
          "data-price": opt.type,
          href: _this2.linkTarget
        }, "Purchase"), _this2.isCurrentObject ? null : _react.default.createElement("a", {
          className: "small-details",
          href: _this2.linkTarget
        }, "View Details")));
      })));
    }
  }, {
    key: "selectTab",
    value: function selectTab(event) {
      this.setState({
        selectedTab: Number(event.target.dataset.index)
      });
    }
  }]);
  return SubscriptionCard;
}(_base.default.makeDefaultCardType('subscription', 'Subscription')), _temp), (_descriptor = babelHelpers.applyDecoratedDescriptor(_class.prototype, "buyButtonAction", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return function () {};
  }
}), _descriptor2 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "id", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), babelHelpers.applyDecoratedDescriptor(_class.prototype, "selectTab", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "selectTab"), _class.prototype)), _class);
exports.default = SubscriptionCard;